/* eslint-disable import/prefer-default-export */
import React from 'react';

const createFocalPoints = (focalPoints: string[] | undefined) => {
  if (!focalPoints) return null;

  const groupedFocalPoints = focalPoints.reduce((acc, focalPoint) => {
    if (!focalPoint) return acc;

    if (!focalPoint.includes('_')) {
      acc.Sonstiges = acc.Sonstiges || [];
      acc.Sonstiges.push(focalPoint.trim());
      return acc;
    }

    const [key, value] = focalPoint.split('_');

    acc[key] = acc[key] || [];
    acc[key].push(value.trim());

    return acc;
  }, {} as Record<string, string[]>);

  return (
    <div>
      {Object.keys(groupedFocalPoints).map(focalpoint => (
        <ul key={focalpoint} className='list-disc my-0 ml-4'>
          <li className='my-0'>
            <strong>{focalpoint}:</strong>
            {groupedFocalPoints[focalpoint].map(subPoint => (
              <span key={subPoint} className='mr-1 break-words'>
                {' '}
                {subPoint};
              </span>
            ))}
          </li>
        </ul>
      ))}
    </div>
  );
};

export default createFocalPoints;
